
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

// export const fetchVendors = async ({
//   limit,
//   page,
//   filters,
//   sort,
//   ret,
//   ref,
//   incl,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     // Make both API calls concurrently
//     const [clientsResponse, totalCountResponse] = await Promise.all([
//       // Fetch paginated clients
//       axios.get(ENDPOINTS.VENDORS.GET_ALL, {
//         params: {
//           coll: "Vendor",
//           lim: limit,
//           pg: page,
//           fil: JSON.stringify(filters),
//           cache: false,
//           sort: JSON.stringify(sort),
//           ret: ret,
//           ref: ref,
//           incl: incl,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),

//       // Fetch total count
//       axios.get(ENDPOINTS.VENDORS.GET_TOTAL_COUNT, {
//         params: {
//           coll: "Vendor",
//           fil: JSON.stringify(filters),
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),
//     ]);
//     return {
//       data: clientsResponse.data,
//       totalCount: totalCountResponse.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//     }
//     throw error;
//   }
// };
export const fetchVendors = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  // Prepare params for both requests
  const commonParams = {
    coll: "Vendor",
    fil: JSON.stringify(filters),
  };
  const vendorsParams = {
    ...commonParams,
    lim: limit,
    pg: page,
    cache: false,
    sort: JSON.stringify(sort),
    ret,
    ref,
    incl,
  };

  // Fetch paginated vendors and total count concurrently
  const [vendorsResult, totalCountResult] = await Promise.all([
    axiosRequest({
      method: "GET",
      url: ENDPOINTS.VENDORS.GET_ALL,
      params: vendorsParams,
    }),
    axiosRequest({
      method: "GET",
      url: ENDPOINTS.VENDORS.GET_TOTAL_COUNT,
      params: commonParams,
    }),
  ]);

  if (!vendorsResult.success) throw new Error(vendorsResult.error);
  if (!totalCountResult.success) throw new Error(totalCountResult.error);

  return {
    data: vendorsResult.data,
    totalCount: totalCountResult.data,
  };
};
// export const fetchOneVendor = async ({ vendorUiid, retrieve, ref }) => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axios.get(ENDPOINTS.VENDORS.GET_BY_UIID, {
//       params: {
//         coll: "Vendor",
//         ret: retrieve,
//         ref: ref,
//         fil: JSON.stringify({ uiid: { type: "NONE", value: vendorUiid } }),
//       },
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       withCredentials: true,
//     });

//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//     }
//     throw error;
//   }
// };
export const fetchOneVendor = async ({ vendorUiid, retrieve, ref }) => {
  const params = {
    coll: "Vendor",
    ret: retrieve,
    ref,
    fil: JSON.stringify({ uiid: { type: "NONE", value: vendorUiid } }),
  };
  const result = await axiosRequest({
    method: "GET",
    url: ENDPOINTS.VENDORS.GET_BY_UIID,
    params,
  });
  if (!result.success) throw new Error(result.error);
  return result.data;
};

// export const addNewVendor = async (vendorData) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.post(
//       ENDPOINTS.VENDORS.ADD_NEW,
//       {
//         coll: "Vendor",
//         payload: vendorData,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to add new client",
//     };
//   }
// };
export const addNewVendor = async (vendorData) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.VENDORS.ADD_NEW,
    data: {
      coll: "Vendor",
      payload: vendorData,
    },
  });
};

// export const updateVendor = async ({ coll, uiid, payload, patchId, tPath }) => {
//   try {
//     const token = localStorage.getItem("token");
//     const params = new URLSearchParams({
//       coll,
//       uiid,
//       ...(patchId && { patchId }),
//       ...(tPath && { tPath }),
//     });
//     const response = await axios.patch(
//       `${ENDPOINTS.VENDORS.UPDATE}?${params.toString()}`,
//       // { payload: payload },
//       { payload },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to update client",
//     };
//   }
// };
export const updateVendor = async ({ coll, uiid, payload, patchId, tPath }) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.VENDORS.UPDATE,
    params,
    data: { payload },
  });
};


// export const addContact = async (payload) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.post(
//       `${ENDPOINTS.VENDORS.ADD_CONTACT}`,
//       {
//         coll: `Contact`,
//         bulkPost: true,
//         payload: payload,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to add contact",
//     };
//   }
// };

export const addContact = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.VENDORS.ADD_CONTACT,
    data: {
      coll: "Contact",
      bulkPost: true,
      payload,
    },
  });
};
// export const updateContact = async ({ coll, uiid, payload }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.patch(
//       `${ENDPOINTS.VENDORS.UPDATE_CONTACT}?coll=${coll}&uiid=${uiid}`,
//       { payload },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data.doc,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to update contact",
//     };
//   }
// };
export const updateContact = async ({ coll, uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.VENDORS.UPDATE_CONTACT,
    params: { coll, uiid },
    data: { payload },
  });
};

// import { ENDPOINTS } from "../../apiConfig";

// export const fetchClients = async ({ limit, page, filters }) => {
//   try {
//     const token = localStorage.getItem("token"); // Get token from localStorage

//     const response = await axios.get(ENDPOINTS.CLIENTS.GET_ALL, {
//       params: {
//         coll: "Client",
//         lim: limit,
//         pg: page,
//         fil: JSON.stringify(filters),
//         cache: false,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });

//     //console.log("API Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//       //console.log("Unauthorized access - please login");
//     }
//     throw error;
//   }
// };
